export function concatNameAndCode (name, code) {
  return name + (code ? (' (' + code + ')') : '')
}
